import Glide from '@glidejs/glide';
import '@glidejs/glide/dist/css/glide.core.min.css';
import './NewsGlide.less';

/**
 * Slider of the news and blog cards. Both sections hold the three latest entries, so at most three
 * cards are shown at once, and fewer on narrow screens, where the next card peeks in.
 */
export default class NewsGlide extends HTMLElement {
  #glide;

  connectedCallback() {
    // Wide screens show every card at once, so the arrows are needed on narrow screens only
    if (this.querySelectorAll('.glide .glide__slide').length <= 3) {
      this.querySelector('.glide__arrows').classList.add('short');
    }

    this.querySelector('.glide-container').classList.add('short');

    this.#glide = new Glide(this.querySelector('.glide'), {
      type: 'slider',
      startAt: 0,
      focusAt: 0,
      perView: 3,
      // Applied up to the given width, so they are listed from the narrowest
      breakpoints: {
        600: { perView: 1.1 },
        768: { perView: 1.8 },
        980: { perView: 2.5 }
      },
      bound: true,
      peek: 0,
      gap: 20,
      animationDuration: 500,
      swipeThreshold: true,
      dragThreshold: true
    });

    this.#glide.mount();
  }

  disconnectedCallback() {
    this.#glide?.destroy();
    this.#glide = undefined;
  }
}

window.customElements.define('news-glide', NewsGlide);
